import { SelectableItem } from '../common/selectableItem';

export enum TenderType {
    High = 100,
    Low = 200,
    PrivateB2B = 300,
    PrivateProject = 400,
    PinHigh = 500,
    PinLow = 600
}

export class TenderTypeToSelectList {
    static getList(): Array<SelectableItem<TenderType>> {
        var output = [] as Array<SelectableItem<TenderType>>;

        output.push({ value: TenderType.High, text: 'High' });
        output.push({ value: TenderType.Low, text: 'Low' });
        output.push({ value: TenderType.PrivateProject, text: 'Private Project' });
        output.push({ value: TenderType.PinHigh, text: 'PIN / Pipeline and Planning – High' });
        output.push({ value: TenderType.PinLow, text: 'Prior Information Notice - Low' });

        return output;
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Client/app/models/tenders/tender.enums.ts